import { z } from 'zod';

import { TransitGroup, TransitStatus } from '@e-origin/shared';

import { optionalBoolean, optionalNumber, optionalString, TransitAddressSchema, TransitContactPersonSchema } from './utils';

export const TransitGeneralInfoSchema = z.object({
  status: z.nativeEnum(TransitStatus).optional().nullable(),
  group: z.nativeEnum(TransitGroup).optional().nullable(),
  totalAmountGuaranteeToBeCovered: optionalNumber(),
});
export type TransitGeneralInfo = z.infer<typeof TransitGeneralInfoSchema>;

export const TransitOperationAmendmentSchema = z.object({
  LRN: optionalString(),
  amendmentTypeFlag: optionalNumber(),
});

export const TransitOperationSchema = z.object({
  LRN: optionalString(),
  declarationType: optionalString(),
  additionalDeclarationType: optionalString(),
  TIRCarnetNumber: optionalString(),
  presentationOfTheGoodsDateAndTime: optionalString(),
  security: optionalString(),
  reducedDatasetIndicator: optionalString(),
  specificCircumstanceIndicator: optionalString(),
  communicationLanguageAtDeparture: optionalString(),
  bindingItinerary: optionalString(),
  limitDate: optionalString(),
  MRN: optionalString(),
  arrivalNotificationDateAndTime: optionalString(),
  simplifiedProcedure: optionalString(),
  incidentFlag: optionalString(),
  discharge: optionalString(),
  voletPageNumber: optionalString(),
  otherThingsToReport: optionalString(),
  releaseRequested: optionalBoolean(),
  amendment: TransitOperationAmendmentSchema.optional(),
});
export type TransitOperation = z.infer<typeof TransitOperationSchema>;

export const TransitAuthorisationSchema = z.object({
  sequenceNumber: optionalString(),
  type: optionalString(),
  referenceNumber: optionalString(),
});

export const GuaranteeReferenceSchema = z.object({
  sequenceNumber: optionalString(),
  GRN: optionalString(),
  accessCode: optionalString(),
  amountToBeCovered: optionalString(),
  currency: optionalString(),
  setFromCustomer: optionalBoolean(),
});

export const GuaranteeSchema = z.object({
  sequenceNumber: optionalString(),
  guaranteeType: optionalString(),
  otherGuaranteeReference: optionalString(),
  GuaranteeReference: z.array(GuaranteeReferenceSchema).optional(),
});

export const HolderOfTheTransitProcedureSchema = z.object({
  identificationNumber: optionalString(),
  TIRHolderIdentificationNumber: optionalString(),
  name: optionalString(),
  Address: TransitAddressSchema.optional(),
  ContactPerson: TransitContactPersonSchema.optional(),
});

export const RepresentativeSchema = z.object({
  identificationNumber: optionalString(),
  status: optionalString(),
  ContactPerson: TransitContactPersonSchema.optional(),
});

export const TraderAtDestinationSchema = z.object({
  identificationNumber: optionalString(),
  communicationLanguageAtDestination: optionalString(),
});

export const UnloadingRemarkSchema = z.object({
  conform: optionalString(),
  unloadingCompletion: optionalString(),
  unloadingDate: optionalString(),
  stateOfSeals: optionalString(),
  unloadingRemark: optionalString(),
});

export const EnquirySchema = z.object({
  TC11DeliveryDate: z.union([z.date(), z.string()]).optional().nullable(),
  text: optionalString(),
});

export const TransitTraceSchema = z.object({
  userId: z.any().optional().nullable(),
  dateTime: optionalString(),
  path: optionalString(),
  initialValue: optionalString(),
  newValue: optionalString(),
  ignore: optionalBoolean(),
});
